import React, { createContext } from 'react';

/**
 * @alpha
 */
const HubSdkContext = createContext(null);
/**
 * @alpha
 */
const HubSdkProvider = ({ children, sdk }) => {
    return React.createElement(HubSdkContext.Provider, { value: sdk }, children);
};

export { HubSdkContext, HubSdkProvider };
//# sourceMappingURL=context.mjs.map
